module.exports = __webpack_public_path__ + "static/media/event-6.9fe95221.jpg";